import React from 'react';
import PropTypes from 'prop-types';
import { Legal } from './styles';
export default function FooterLegal({
  children
}) {
  return /*#__PURE__*/React.createElement(Legal, {
    className: "footer-info__disclaimer section--lg",
    id: "disclaimer"
  }, children);
}
FooterLegal.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=legal.js.map